var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToolLayoutDefault = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.25
}, /*#__PURE__*/React.createElement("path", {
  d: "M.5 13.495v7.9a2 2 0 0 0 2 2h11.244M19.695 12V6a2 2 0 0 0-2-2h-7.7 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4 4H2.5a2 2 0 0 0-2 2v7.7h0"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  opacity: 0.55
}, /*#__PURE__*/React.createElement("path", {
  d: "M10 20.5v-14M3 13.5h13"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#348CFD",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  transform: "rotate(-20 57.344 -33.161)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5.124,
  cy: 5.767,
  r: 1.282
}), /*#__PURE__*/React.createElement("path", {
  d: "m6.214.808.377 1.241a.85.85 0 0 0 1.003.582l1.259-.292a1.144 1.144 0 0 1 1.089 1.896l-.88.95a.856.856 0 0 0 0 1.16l.88.949a1.144 1.144 0 0 1-1.09 1.896l-1.258-.292a.85.85 0 0 0-1.007.586l-.377 1.241a1.138 1.138 0 0 1-2.179 0l-.374-1.241A.85.85 0 0 0 2.654 8.9l-1.258.292a1.144 1.144 0 0 1-1.09-1.896l.881-.95a.856.856 0 0 0 0-1.16l-.88-.95a1.144 1.144 0 0 1 1.089-1.895l1.258.291a.85.85 0 0 0 1.003-.581L4.035.81A1.138 1.138 0 0 1 6.214.808"
}))))));
export { SvgToolLayoutDefault as ReactComponent };
export default __webpack_public_path__ + "assets/images/tool-layout-default.svg";